import { TaskType } from 'app/constants/taskType'

export const getTaskType = (type): TaskType => {
  let taskType = TaskType.Import

  switch (type) {
    case 1:
      taskType = TaskType.Timesheet
      break
    case 2:
      taskType = TaskType.Printout
      break
    case 3:
      taskType = TaskType.Violation
      break
    case 4:
      taskType = TaskType.SaveImport
      break
    case 5:
      taskType = TaskType.ImiExport
      break
    case 6:
      taskType = TaskType.BusinessTrip
      break
  }

  return taskType
}
